import React from "react";
import { ScheduleEditor } from "../editors";

/**
 * Profile → Schedule tab. Manual-only vs. manual + scheduled (cadence, time, next run).
 */

export default function SchedulePanel({ id }: { id: string }) {
  return <ScheduleEditor id={id} />;
}
